export interface IWeatherStation {
    weatherStationId: number;
    weatherFileName: string;
    city: string;
    state: string;
    code: string;
    latitude: number;
    longitude: number;
}

export class WeatherStation implements IWeatherStation {
    public weatherStationId: number;
    public weatherFileName: string;
    public city: string;
    public state: string;
    public code: string;
    public latitude: number;
    public longitude: number;
}